import { Component, Inject, OnInit, DOCUMENT, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { EnvironmentService } from 'src/app/environment/environment.service';


@Component({
    selector: 'app-jupiter-redirect',
    templateUrl: './jupiter-redirect.component.html',
    styleUrls: ['./jupiter-redirect.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class JupiterRedirectComponent implements OnInit {
  private router: Router;
  private env: EnvironmentService;
  constructor(
    public document: Document,
    router: Router,
    env: EnvironmentService
  ) {
    this.env = env;
    this.router = router;
  }

  ngOnInit(): void {
    this.document.location.assign(this.env.jupiter_url + this.router.url);
  }
}
